import moment from 'moment'
import store from '@/store'
const enumsData = store.state.enumsStore.enumsData

export const logTypes = enumsData.OperateType

export const searchItems = [
  // 用户名称
  {
    label: '员工名称',
    type: 'input',
    decorator: ['userName'],
    placeholder: '员工名称'
  },
  {
    label: '员工手机号码',
    type: 'input',
    decorator: ['userPhone'],
    placeholder: '请输入员工手机号码'
  },
  // 日志类型
  {
    label: '日志类型',
    type: 'select',
    decorator: ['operateType'],
    placeholder: '请选择日志类型(不选表示全部)',
    mode: 'multiple',
    option: { data: logTypes, keyName: 'code', valName: 'name' }
  },
  // 查询时间
  {
    label: '查询时间',
    type: 'timeRange',
    decorator: [
      'dateTimeRange',
      {
        initialValue: [moment().startOf('day'), moment().endOf('day')]
      }
    ],
    placeholder: ['查询时间 (起始)', '查询时间 (终止)'],
    disabledDate: c => c && c > moment().endOf('day'),
    ranges: {
      今日: [moment().startOf('day'), moment().endOf('day')],
      近一周: [moment().subtract(7, 'days').startOf('day'), moment().endOf('day')],
      近两周: [moment().subtract(15, 'days').startOf('day'), moment().endOf('day')],
      近一月: [moment().subtract(30, 'days').startOf('day'), moment().endOf('day')]
    }
  }
]
